import { defineComponent } from '@vue/composition-api';
import HomeCarousel from '@/Home/components/HomeCarousel.vue';
export default defineComponent({
    components: {
        HomeCarousel
    },
    props: {
        blok: {
            type: Object,
            default: null
        }
    }
});
